import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { KieneApi } from '../../../../../../../../src/app/components/kiene-table/kiene-api';
import { KieneTableService } from '../../../../../../../../src/app/components/kiene-table/kiene-table.service';
import { API_BASE_URL_SERVICE } from '../../../../kiene-core.config';
import { AppService } from '../../../../services/app/app.service';
import { Gruppe } from '../../classes/gruppe';
import { GruppeBewegung } from './tod-melden-dialog';
import { TodesArt } from '../../../gruppe-tier/classes/todes-art';
import { GruppenService } from '../../gruppen.service';
import { MessageService } from '../../../../services/message-service/message.service';

@Component({
    selector: 'kiene-tod-melden-dialog',
    templateUrl: './tod-melden-dialog.component.html',
    styleUrls: ['./tod-melden-dialog.component.scss'],
})
export class TodMeldenDialogComponent implements OnInit {
    anzahlTiereCtrl: FormControl = new FormControl(undefined, [Validators.required, Validators.min(1)]);
    todesdatumCtrl: FormControl = new FormControl(undefined, [Validators.required]);
    abteilCtrl: FormControl = new FormControl();
    mailCheckboxCtrl: FormControl = new FormControl();
    selectedTodesartCtrl: FormControl = new FormControl();
    todesarten: TodesArt[] = [];
    isSaving = false;
    isMobile = false;

    constructor(
        public dialogRef: MatDialogRef<TodMeldenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) protected gruppe: Gruppe,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly messageService: MessageService,
        private readonly api: KieneTableService,
        private readonly appService: AppService,
        private readonly gruppenService: GruppenService,
    ) {}

    ngOnInit(): void {
        this.isMobile = this.appService.isMobileScreen;
        let params = new HttpParams().set('kunde_id', this.gruppe?.kunde_id);
        params = params.set('limit', 1);
        params = params.set('orderby', 'datum desc');
        params = params.set('bewegung_typ', 3);
        this.api.get(this.apiBaseUrl + 'gruppe_bewegung/read.php', params).subscribe({
            next: (response: KieneApi) => {
                if (response?.count > 0) {
                    const gb: GruppeBewegung = response.records[0];
                    if (gb?.mail_entsorger > 0) {
                        this.mailCheckboxCtrl.setValue(true);
                    }
                }
            },
            error: err => {
                this.messageService.errorMessage('Entsorger Mail Einstellung konnte nicht geladen werden!', err);
            },
        });

        this.ladeTodesarten();
    }

    ladeTodesarten(): void {
        this.gruppenService.loadTodesarten().subscribe({
            next: todesarten => {
                this.todesarten = todesarten.records;
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden der Todesarten', err);
            },
        });
    }

    public save(): void {
        this.isSaving = true;
        const data = new GruppeBewegung();
        data.gruppe_id = this.gruppe.gruppe_id;
        data.anzahl_tiere = this.anzahlTiereCtrl.value;
        data.datum = this.todesdatumCtrl.value;
        data.abteil = this.abteilCtrl.value;
        data.mail_entsorger = this.mailCheckboxCtrl.value ? 1 : 0;
        data.todesart_id = this.selectedTodesartCtrl.value?.todesart_id;
        data.an_hit_melden = 0;
        data.bewegung_typ = 3;

        this.api.post(this.apiBaseUrl + 'gruppe_bewegung/update.php', data).subscribe({
            next: () => {
                this.dialogRef.close(true);
            },
            error: err => {
                this.isSaving = false;
                this.messageService.errorMessage('Tod melden fehlgeschlagen!', err);
            },
        });
    }

    public isDisabled(): boolean {
        return this.anzahlTiereCtrl.invalid || this.todesdatumCtrl.invalid || this.isSaving;
    }
}
